export default __webpack_public_path__ + "static/media/noise_texture.a7bc52b3.png";